import React, {Component} from "react";

class Check extends Component {
	render() {
		const styles = {
			border  : '1px solid #222',
			padding : '10px 20px',
		};

		const pStyle = {
			lineHeight : "16px"
		};

		const {payment} = this.props;

		const amount = (payment.amount * 1.00).toFixed(2);
		const nalog = (payment.amount * 0.04).toFixed(2);
		const toPay = (payment.amount * 0.96).toFixed(2);

		return (
			<div style={styles}>
				<div>
					<h2>Документ, подтверждающий выплату</h2>
					<p style={pStyle}>ООО "Финансово-инвестиционная компания "ИНХО"</p>
					<p style={pStyle}>УНП 191318808</p>
				</div>
				<div>
					<h2>Выплата выигрыша</h2>
					<p style={pStyle}>№ платежного поручения (транзакции) {payment.id}</p>
					<p style={pStyle}>Сумма выигрыша {amount} рублей</p>
					<p style={pStyle}>Сумма подоходного налога {nalog} рублей</p>
					<p style={pStyle}>Сумма к выплате {toPay} рублей</p>
					<p style={pStyle}>ФИО (участника букмекерской игры) </p>
				</div>
			</div>
		);
	}
}

export default Check;


// WEBPACK FOOTER //
// ./src/app/pages/User/Payments/Check.js